import { render, staticRenderFns } from "./UtilidadProducto.vue?vue&type=template&id=cc36277c&scoped=true"
import script from "./UtilidadProducto.vue?vue&type=script&lang=js"
export * from "./UtilidadProducto.vue?vue&type=script&lang=js"
import style1 from "./UtilidadProducto.vue?vue&type=style&index=1&id=cc36277c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc36277c",
  null
  
)

export default component.exports